import React, { Component } from 'react';
import PropTypes, { element } from 'prop-types';
import classnames from 'classnames';
import FilterPane from 'Components/FilterPane';
import { getDataAccordingToSearchFilters } from '../../api/searchFilterApi';
import { exportCaseSearchQueueData } from 'Apis/exportApi';
import GDTable from 'Components/GDTable';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import EmptyState from 'Components/EmptyState/EmptyState';
import { getTranslations } from '../QueueLanding/configStructure';
import './CaseSearch.scss';
import ResponseBanner from 'Components/cards/ResponseBanner/ResponseBanner';
import { isObject } from 'util';
import moment from 'moment';
import { connect } from 'react-redux';
import { fetchFilterElements } from '../../actions/searchFilterAction';
import { getFilterValuesBasedOnElementId, postActiveFilters , getFilterValuesBasedOnElementIdWithAcquirer } from '../../api/caseDataAPI';
import { setSearchOpenFlag } from 'Actions/drawerAction';
import { fetchDataColumns } from 'Actions/dataColumnsAction';
import { getToken } from 'Apis/tokenizeFilterElement';
import GDActiveFiltersDropdown from 'Components/GDActiveFiltersDropdown/GDActiveFiltersDropdown';
import LinkInlineButton from 'Components/Button/LinkInlineButton';
import GDNewFilterDropdown from 'Components/GDNewFilterDropdown';
import OptionBoxPopup from 'Components/OptionBoxPopup';
import StarIcon from 'Components/icons/StarIcon';
import GDSavedFiltersDropdown from 'Components/GDSavedFiltersDropdown';
import { fetchSavedFilterElements, saveActiveFilters, deleteSavedFilters } from 'Actions/savedFilterAction';
import { fetchSearchTypeIdBasedOnSearchName } from 'Actions/searchFilterAction';
import {
  mapSavedFilters,
} from 'Utils/reports/reportFilterUtils';
import {
  postBookMarkCase,
  undoBookMarkCase,
} from 'Apis/queueManagerApi.js';
import { gotoNewTabCaseLandingPage } from 'Utils/newTabUtils.jsx';
import { downloadFile } from 'Utils/exportFunctionality.js';
import {
  dangerNotificationBanner,
  closeNotificationBanner,
} from 'Actions/notificationAction';
import * as KeyConstants from 'Utils/constants/keyConstants.js';
import { getSortArray } from 'Utils/sortArrayUtil.js';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';
import { VITE_DiMS_INTERNAL_EMPLOYEE } from 'Constants/appEnvConstants';
import { flushSync } from 'react-dom';
import { getCaseSearchFilterList, getFilterTranslations, getValidations, addIconsToGDTableHeadersList } from './configFilterStructure';
import ImagePortal from '../ImagePortal/ImagePortal';
import { isEmpty } from 'Utils/lodashUtils.js';

export class CaseSearch extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isVisible: true,
      activeFilters: [],
      filters: [],
      isLoading: true,
      scrollPos: 0,
      totalPages: 0,
      structureMetaData: {},
      caseData: [],
      data: [],
      totalRecords: 0,
      recordsShown: 0,
      currentPage: 0,
      isNextPage: false,
      caseDataErr: false,
      exporting: false,
      filterExportIsVisible: false,
      appliedFilters: [],
      gridSortArray: getCaseSearchFilterList().defaultSort,
      dateFormat: getCaseSearchFilterList().dateFormat,
      filterText: '',
      savedFilterTranslations: {},
      isRequiredFilter: false,
      isTableVisible: false,
      apiMultiSelectCount: 0,
      multiSelectLength: 0,
      finalFilterElements: [],
      isLoadingComplete: true,
      dataColumns: [],
      filterName: '',
      saveFilterToggled: false,
      savedFilters: [],
      dropdownToggled: {
        active: false,
        inactive: false,
      },
      saveFilterFail: false,
      bookMarkedRows: [],
      isBookMarked: false,
      isFirstCall: true,
      setSize: false,
      mID: '',
      selectedRow:[],
      existingScheduleFilters: [],
    };
    this.attachBindings();
  };

  attachBindings() {
    this.toggleFilterPane = this.toggleFilterPane.bind(this);
    this.closeFilterPane = this.closeFilterPane.bind(this);
    this.rowActionClick = this.rowActionClick.bind(this);
    this.resetScrollPos = this.resetScrollPos.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.getAllMultiSelectData = this.getAllMultiSelectData.bind(this);
    this.saveCurrentlyVisibleColumns = this.saveCurrentlyVisibleColumns.bind(this);
    this.getTokenFromCardNumber = this.getTokenFromCardNumber.bind(this);
    this.toggleSavedFilter = this.toggleSavedFilter.bind(this);
    this.onChange = this.onChange.bind(this);
    this.removeSavedFilter = this.removeSavedFilter.bind(this);
    this.setSavedFilterAsActive = this.setSavedFilterAsActive.bind(this);
    this.clearAllFilters = this.clearAllFilters.bind(this);
    this.saveFilterName = this.saveFilterName.bind(this);
    this.updateSearchField = this.updateSearchField.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.deactivateFilter = this.deactivateFilter.bind(this);
    this.closeSaveFilterFailBanner = this.closeSaveFilterFailBanner.bind(this);
    this.onBookMarked = this.onBookMarked.bind(this);
    this.fetchFiltersBySearchTypeId = this.fetchFiltersBySearchTypeId.bind(this);
    this.checkSize = this.checkSize.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.handleMIDSearch = this.handleMIDSearch.bind(this);
  };

  componentWillMount() {
    this.fetchFiltersBySearchTypeId(getCaseSearchFilterList().id);
    this.props.fetchDataColumns(getCaseSearchFilterList().pageId);
    document.addEventListener('keydown', this.onKeyPress);
    document.addEventListener('keypress', this.onKeyPress);
  };

  componentWillReceiveProps(nextProps) {

    if (this.props.filters.length !== nextProps.filters.length) {
      const mergeFilter = this.mergeElementIdsForRangeElements(nextProps.filters);
      const filtersWithValidations = mergeFilter.map((filter) => {
        return {
          ...filter,
          validations: getValidations(filter.elementTypeName) === undefined ? [] : getValidations(filter.elementTypeName).validations,
        };
      });

      let multiSelectFiltersIds = [];
      filtersWithValidations.forEach((filter) => {
        if (filter.elementTypeName === 'MULTISELECT') {
          multiSelectFiltersIds = multiSelectFiltersIds.concat(filter.elementId);
        }
        if (filter.elementTypeName === 'SELECT' && filter.elementId === 'case_card_brand') {
          multiSelectFiltersIds = multiSelectFiltersIds.concat(filter.elementId);
         
        } 
      });
      multiSelectFiltersIds.forEach((multiSelectFiltersId) => {
        this.getAllMultiSelectData(multiSelectFiltersId, multiSelectFiltersIds.length);
      });
      this.setState({
        formattedFilters: filtersWithValidations,
        multiSelectFiltersIds,
      });
    }
    if (this.props.location !== nextProps.location || this.state?.dataColumns?.length == 0 || this.props?.dataColumns?.length !== nextProps.dataColumns?.length) {
      this.setState({
        dataColumns: nextProps.dataColumns,
      });
    }

    if (this.props.savedFilters.length !== nextProps.savedFilters.length || this.props.savedFilters !== nextProps.savedFilters) {
      const savedFilters = this.mergeSavedElementIdsForRangeElements(nextProps.savedFilters);
      this.setState({
        savedFilters: savedFilters,
        noSavedFilters: savedFilters.length > 0 ? false : true,
      });
    }
  };

  componentDidMount() {
    scroll(0, 0);
    let role = JSON.parse(sessionStorage.getItem('state')).auth.user.role;
    let source= JSON.parse(sessionStorage.getItem('state')).auth.user.source;
    let userMXPermissions = JSON.parse(sessionStorage.getItem('state')).auth.user.parsedPermissions.queue.viewMxQueues;
    let userGPPermissions = JSON.parse(sessionStorage.getItem('state')).auth.user.parsedPermissions.queue.viewGPNQueues;
    let userHPYPermissions = JSON.parse(sessionStorage.getItem('state')).auth.user.parsedPermissions.queue.viewHPYQueues ;   
    let userEVOPermission  = JSON.parse(sessionStorage.getItem('state')).auth.user.parsedPermissions.queue.viewEvoQueues;
    let userGPEPermission  = JSON.parse(sessionStorage.getItem('state')).auth.user.parsedPermissions.queue.viewGPEQueues;
     if (role.key == VITE_DiMS_INTERNAL_EMPLOYEE) {
      if(source =='ACCOUNTS') {
          if(userMXPermissions || userGPPermissions){
          this.setState({
            canViewHierarchySelector:false,
            canViewGpnAccountsSelector:true,
            canViewEvoAccountsSelector:false,
            canViewHpyAccountsSelector:false,
            canViewGpeAccountsSelector:false,
          })
        }else if(userHPYPermissions){
          this.setState({
            canViewHierarchySelector:false,
            canViewGpnAccountsSelector:false,
            canViewEvoAccountsSelector:false,
            canViewHpyAccountsSelector:true,
            canViewGpeAccountsSelector:false,
          })
        }else if(userEVOPermission){
          this.setState({
              canViewHierarchySelector:false,
              canViewEvoAccountsSelector:true,
              canViewGpnAccountsSelector:false,
              canViewHpyAccountsSelector:false,
              canViewGpeAccountsSelector:false,
          })
        }
        else if(userGPEPermission){
          this.setState({
              canViewHierarchySelector:false,
              canViewEvoAccountsSelector:false,
              canViewGpnAccountsSelector:false,
              canViewHpyAccountsSelector:false,
              canViewGpeAccountsSelector:true,
          })
        }
      }
      else {
        this.setState({
          canViewHierarchySelector: true,
          canViewGpnAccountsSelector:false,
          canViewEvoAccountsSelector:false,
          canViewHpyAccountsSelector:false,
          canViewGpeAccountsSelector:false,
        })
      }
    }
    if (this.state.isVisible === true && document.getElementById('case-body')) {
      document.getElementById('case-body').style.maxHeight = '200px';
    }
  };

  componentWillUpdate(nextProps, nextState) {
    if (this.state.caseData.length !== nextState.caseData.length || this.state.bookMarkedRows.length == 0) {
      nextState.caseData.map((rowVal) => {
        if (rowVal.bookmarkedBy) {
          this.setState((prevState) => ({
            bookMarkedRows: prevState.bookMarkedRows.concat(rowVal.caseStageId),
          }));
        }
      })
    }
  };

  componentDidUpdate() {
    if (this.state.isVisible === true && document.getElementById('case-body')) {
      document.getElementById('case-body').style.maxHeight = '200px';
    } else if (this.state.isTableVisible === true && document.getElementById('case-body')) {
      document.getElementById('case-body').style.maxHeight = '286px';
    }
    if (this.state.finalFilterElements.length == 0 && this.state.apiMultiSelectCount > 0 && this.state.multiSelectLength === this.state.apiMultiSelectCount) {
      const finalFilterElements = this.state.formattedFilters.map((filterElement) => {
        if (this.state.multiSelectFiltersIds.indexOf(filterElement.elementId) === -1) {
          return filterElement;
        } else {
          return {
            filterValues: this.state[filterElement.elementId],
            ...filterElement,
          };
        }
      });
      this.setState({
        finalFilterElements,
        isLoading: false,
      });
    }
  };

  componentWillUnmount() {
    this.props.fetchFilterElements(-1);
    document.removeEventListener('keydown', this.onKeyPress);
    document.removeEventListener('keypress', this.onKeyPress);
    if (document.getElementById('case-body'))
      document.getElementById('case-body').style.maxHeight = '286px';
  };

  onKeyPress(event) {
    const eventCode = event.code ? (event.code + '_' + event.ctrlKey) : event.key + '_' + event.ctrlKey;
    switch (eventCode) {
      case KeyConstants.ESCAPE_BUTTON:
      case KeyConstants.ESCAPE_KEY_CODE_BUTTON:
        this.closeBanner();
        this.closeSaveFilterFailBanner();
        break;
    }
  };

  fetchFiltersBySearchTypeId(searchTypeId) {
    this.setState({
      searchTypeId,
    });
    this.props.fetchFilterElements(searchTypeId);
    this.props.fetchSavedFilterElements(searchTypeId);
  };

  getAllMultiSelectData(multiSelectFiltersId, multiSelectLength) {
    let acquirerAccessList= getAcquirerAccessList();
    if ( multiSelectFiltersId === 'case_card_brand' && acquirerAccessList) {
      getFilterValuesBasedOnElementIdWithAcquirer(multiSelectFiltersId, acquirerAccessList)
      .then((response) => {
        const formattedData = this.getFormattedResponse(response, multiSelectFiltersId);
        this.setState((prevState) => ({
          multiSelectLength,
          [multiSelectFiltersId]: formattedData,
          apiMultiSelectCount: prevState.apiMultiSelectCount + 1,
        }));
      })
      .catch((error) => {
        console.log('Error Occured while fetching filter values based on element id', error);
      });

    } else {
      getFilterValuesBasedOnElementId(multiSelectFiltersId)
      .then((response) => {
        const formattedData = this.getFormattedResponse(response, multiSelectFiltersId);
        this.setState((prevState) => ({
            multiSelectLength,
            [multiSelectFiltersId]: formattedData,
            apiMultiSelectCount: prevState.apiMultiSelectCount + 1,
        }));
      })
      .catch((error) => {
        console.log('Error Occured while fetching filter values based on element id', error);
      });
    } 
  };

  getFormattedResponse(response, filter) {
    let filterValues = [];
    response.data.forEach((filterValue) => {
      if (filter === 'case_type') {
        filterValues = filterValues.concat({
          id: filterValue.stageId,
          value: filterValue.stageId,
          text: filterValue.stageName,
        });
      }
      if (filter === 'case_status') {
        filterValues = filterValues.concat({
          id: filterValue.statusId,
          value: filterValue.statusId,
          text: filterValue.statusName,
        });
      }
      if (filter === 'hpy_petro_name') {
        filterValues = filterValues.concat({
          id: filterValue.petroPayId,
          value: filterValue.petroPayId,
          text: filterValue.petroPayName,
        });
      }
      if (filter === 'case_card_brand') {
        filterValues = filterValues.concat({
          id: filterValue.cardBrandCode,
          value: filterValue.cardBrandCode,
          valueLabel: filterValue.cardBrandName,
        });
       
      }
    });
    return filterValues;
  };

  getDataAccordingToSearchFilters(filters, filterTypeId, pageNumber, size, sortArray, lazyLoad) {
    let acquirerAccessList= getAcquirerAccessList();
    const structureMetaData = getCaseSearchFilterList();
    structureMetaData.dataColumns = addIconsToGDTableHeadersList(this.state.dataColumns);
    setTimeout(() =>
      this.setState(() => ({
        structureMetaData,
        recordsShown: size,
        caseDataErr: false,
        isLoading: false,
        gridSortArray: sortArray,
        isTableVisible: true,
        lazyLoadPageNumber: pageNumber,
        filterTypeId,
        appliedFilters: filters,
        acquirerAccessList:acquirerAccessList,
      })),
      500)
  };

  pageHandler = (newPage, newPerPage) => {
    this.setState({
      isLoading: true,
    });
    scroll(0, 0);
    const pageSize = newPerPage === undefined ? this.state.recordsShown : newPerPage;
    if (newPage) {
      this.getDataAccordingToSearchFilters(this.state.appliedFilters, getCaseSearchFilterList().id, newPage - 1, pageSize, this.state.gridSortArray);
    }
  };

  toggleFilterPane = () => {
    document.body.classList.add('instant-header');
    scroll(0, 0);
    if (this.props.filters.length === 0 && !this.state.isVisible) {
      this.props.fetchFilterElements(this.state.searchTypeId);
      this.props.fetchSavedFilterElements(this.state.searchTypeId);
    }
    this.setState(
      {
        isVisible: !this.state.isVisible,
      },
    );
  };

  mapActiveFilters(filters = [], data = []) {
    const results = [];
    filters.forEach((filter) => {
      // 'opco' is exposed to the search API as 'company' (see prepareResponseForSearchApi),
      // so also accept a 'company' elementId here in case the filter metadata list defines it that way.
      const matchingFilter = data.find((column) => (column.elementId) === (filter.id) || (filter.id === 'opco' && column.elementId === 'company'));
      if (matchingFilter &&
        matchingFilter.elementLabel) {
        results.push(
          Object.assign({}, filter, {
            name: matchingFilter.elementLabel,
            value: !filter.v2 ? filter.v1 : null,
            values: filter.v2 ? { v1: filter.v1, v2: filter.v2 } : null,
            v1: filter.v1,
            v2: filter.v2,
            category: matchingFilter.elementCategoryName,
            elementType: matchingFilter.elementTypeName,
          }),
        );
      }
    });
    return results;
  };

  handleMIDSearch = (merchant) => {
    this.setState({mID: merchant});
  };

  applyFilters(newValues, filterList) {
    delete newValues["acquirerCode"];
    const allHierarchyCodeTierNames=['corporate', 'region', 'principal', 'associate', 'chain','group', 'taxid', 'opco', 'acquirer', 'contract'];
    
    const role = JSON.parse(sessionStorage.getItem('state'))?.auth?.user?.role;

    const newFilterValues = this.convertJsonObjectToArray(newValues, filterList);
    let isOnehierarchyAndFilterValSelected=false;
    const indexOfMerchantNumberObj=newFilterValues?.findIndex(({id})=>id === 'merchant_number');
    if(indexOfMerchantNumberObj !== -1 && !isEmpty(newFilterValues[indexOfMerchantNumberObj]?.v1)){
      isOnehierarchyAndFilterValSelected=true;
    }else{
      /*
      * First condition to check atleast one value from filter is select
      */
       const hasNonHierarchyFilterWithValue = newFilterValues
      .filter(item => !allHierarchyCodeTierNames.includes(item.id))
      .some(el => !isEmpty(el?.v1));
      /*
      * Second condtion to check at least one value from hierarchy dropdown is select except MID
      */
      const hasHierarchyFilterSelected = newFilterValues
      .some(item => allHierarchyCodeTierNames.includes(item.id) && !isEmpty(item?.v1));

      isOnehierarchyAndFilterValSelected = (hasNonHierarchyFilterWithValue || hasHierarchyFilterSelected) || false;

    }
    
      let isRequiredFilter = false;

    if ((isEmpty(newFilterValues))||((!isOnehierarchyAndFilterValSelected && role.key === VITE_DiMS_INTERNAL_EMPLOYEE ))) {
      isRequiredFilter = true;
      const newActiveFilters = this.mapActiveFilters(newFilterValues, this.state.finalFilterElements);
      this.setState({
        isRequiredFilter,
        isVisible: true,
        caseData: [],
        activeFilters: newActiveFilters,
      });
    } else {
      const newActiveFilters = this.mapActiveFilters(newFilterValues, this.state.finalFilterElements);
      this.setState({
        isVisible: false,
        activeFilters: newActiveFilters,
        isLoading: true,
        isRequiredFilter: false,
        caseData: [],
      });
      let filterParams = this.prepareResponseForSearchApi(newActiveFilters);
      let isInvalidFilter = false;
      let accountNumberFilter = filterParams.find(data => data.fieldId == 'case_account_number');
      if (accountNumberFilter && !isRequiredFilter && !isInvalidFilter) {
        this.getTokenFromCardNumber(accountNumberFilter.fieldValues1, filterParams);
      } else {
        !isRequiredFilter && !isInvalidFilter && this.getDataAccordingToSearchFilters(filterParams, getCaseSearchFilterList().id, 0, getCaseSearchFilterList().pageSize, this.state.gridSortArray);
      }
    }
    scroll(0, 0);
  };

  searchByAllMerchant_Hierarchy() {
    let orgResponse = this.props.cachedLoginUserOrgs;
      let merchantHierarchyList = [];
      Object.entries(orgResponse).forEach(([key, val]) => {
        if(key !== 'TOP_LEVEL' && val.some(v => v.merchantNumber)) {
          merchantHierarchyList = [...merchantHierarchyList, ...val];
        }
      });
      return merchantHierarchyList;
  };

  convertJsonObjectToArray(newValues, filterList = []) {
    let newFilterValues = [];
    if (this.state.canViewHierarchySelector && newValues.merchant_hierarchy && newValues.merchant_hierarchy.v1 && newValues.merchant_hierarchy.v1.length > 0) {
      let merchantList = [];
      let merchantSelectedList = newValues.merchant_hierarchy.v1 && newValues.merchant_hierarchy.v1[0] && newValues.merchant_hierarchy.v1[0].row && newValues.merchant_hierarchy.v1[0].row[5] ? newValues.merchant_hierarchy.v1[0].row[5].selectedItems : undefined;
      let merchantItemList =  newValues.merchant_hierarchy.v1&& newValues.merchant_hierarchy.v1[0] && newValues.merchant_hierarchy.v1[0].row && newValues.merchant_hierarchy.v1[0].row[5]?newValues.merchant_hierarchy.v1[0].row[5].items:undefined;
      if ((merchantSelectedList && merchantSelectedList.length == 1 && merchantSelectedList[0].id=="All") || ((merchantSelectedList && merchantSelectedList.length==0) || (!merchantSelectedList))) {
        if (newValues.merchant_hierarchy.v1[0].row[4].selectedItems && newValues.merchant_hierarchy.v1[0].row[4].selectedItems.length > 0) {
          newValues.merchant_hierarchy.v2 = newValues.merchant_hierarchy.v1[0].row[4].selectedItems[0].orgId;
          if (newValues.merchant_hierarchy.v2) {
            merchantList.push('All');
          } else {
            for (let i = 1; i < merchantItemList.length; i++) {
              merchantItemList[i].merchantNumber && merchantList.push(merchantItemList[i].merchantNumber);
            
            }
          }
        } else {
          newValues.merchant_hierarchy.v1 = [];
        }
      }  
      if (merchantSelectedList) {
        for (let i = 0; i < merchantSelectedList.length; i++) {
          merchantSelectedList[i].merchantNumber && merchantList.push(merchantSelectedList[i].merchantNumber);
        }
      }
      if ((merchantSelectedList === undefined || merchantSelectedList.length == 0) && this.state.mID != undefined && this.state.mID.trim().length !== 0) {
        merchantList.push(this.state.mID);
        this.setState({ mID: '' });
      }
      this.setState({
        merchant_hierarchy: Object.assign({}, newValues.merchant_hierarchy)
      });
      newValues.merchant_hierarchy.v1 = merchantList;
    }
    if (this.state.canViewGpnAccountsSelector) {
      if (newValues.selectedHierarchies?.v1?.length > 0) {
        if (newValues.selectedHierarchies?.v1[0][0].length > 0) {
          newValues.corporate = {
            v1 : [newValues.selectedHierarchies.v1[0][0][0].mainLine],
          }
          newValues.manualSearchMid = [];
        }
        newValues.region = {};
        if(newValues.selectedHierarchies?.v1[0][1].length > 0){
          newValues.region = {
            v1 : [newValues.selectedHierarchies.v1[0][1][0].mainLine],
          }
        }
        newValues.principal = {};
        if(newValues.selectedHierarchies?.v1[0][2].length > 0){
          newValues.principal = {
            v1 :[newValues.selectedHierarchies.v1[0][2][0].mainLine],
          }
        }
        newValues.associate = {};
        if(newValues.selectedHierarchies?.v1[0][3].length > 0){
          newValues.associate = {
            v1 : [newValues.selectedHierarchies.v1[0][3][0].mainLine],
          }
        }
        newValues.chain = {};
        if(newValues.selectedHierarchies?.v1[0][4].length > 0){
          newValues.chain = {
            v1 : [newValues.selectedHierarchies.v1[0][4][0].mainLine],
          }
        }
        newValues.merchant_number = {};
        if(newValues.selectedHierarchies?.v1[0][5].length > 0 && newValues.selectedHierarchies?.v1[0][5][0].mainLine != 'All'){
          newValues.merchant_number = {
            v1 : newValues.selectedHierarchies.v1[0][5].map(e => e.mainLine),
          }
        }
      }
    }

    if(this.state.canViewHpyAccountsSelector){
          if (newValues.selectedHierarchies?.v1?.length > 0){
            
              newValues.chain = {};
              if(newValues.selectedHierarchies?.v1[0][0].length > 0){
                newValues.chain = {
                  v1: [newValues.selectedHierarchies.v1[0][0][0].mainLine],
                }
              }
          
              newValues.merchant_number = {};
              if(newValues.selectedHierarchies?.v1[0][1].length > 0 && newValues.selectedHierarchies?.v1[0][1][0].mainLine != 'All'){
                newValues.merchant_number = {
                  v1: newValues.selectedHierarchies.v1[0][1].map(e => e.mainLine),
                }
              }
            } 
    }

    if(this.state.canViewEvoAccountsSelector){
        if (newValues.selectedHierarchies?.v1?.length > 0){
          newValues.group = {};
          if(newValues.selectedHierarchies?.v1[0][0].length > 0){
            newValues.group = {
              v1: [newValues.selectedHierarchies.v1[0][0][0].mainLine],
            }
            newValues.manualSearchMid = [];
           }
          newValues.chain = {};
          if(newValues.selectedHierarchies?.v1[0][1].length > 0){
            newValues.chain = {
              v1: [newValues.selectedHierarchies.v1[0][1][0].mainLine],
            }
          }
          newValues.tax_id = {};
          if(newValues.selectedHierarchies?.v1[0][2].length > 0){
            newValues.tax_id = {
              v1: [newValues.selectedHierarchies.v1[0][2][0].mainLine],
            }
          }
          newValues.merchant_number = {};
          if(newValues.selectedHierarchies?.v1[0][3].length > 0 && newValues.selectedHierarchies?.v1[0][3][0].mainLine != 'All'){
            newValues.merchant_number = {
              v1: newValues.selectedHierarchies.v1[0][3].map(e => e.mainLine),
            }
          }
        } 
    }

    if (this.state.canViewGpeAccountsSelector) {
      if (newValues.selectedHierarchies?.v1?.length > 0) {
        newValues.opco = {};
        if (newValues.selectedHierarchies?.v1[0][0].length > 0) {
          newValues.opco = {
            v1: [newValues.selectedHierarchies.v1[0][0][0].mainLine],
          };
          newValues.manualSearchMid = [];
        }

        newValues.acquirer = {};
        if (newValues.selectedHierarchies?.v1[0][1].length > 0) {
          newValues.acquirer = {
            v1: [newValues.selectedHierarchies.v1[0][1][0].mainLine],
          };
        }

        newValues.contract = {};
        if (newValues.selectedHierarchies?.v1[0][2].length > 0) {
          newValues.contract = {
            v1: [newValues.selectedHierarchies.v1[0][2][0].mainLine],
          };
        }

        newValues.merchant_number = {};
        if (newValues.selectedHierarchies?.v1[0][3].length > 0 && newValues.selectedHierarchies?.v1[0][3][0].mainLine != 'All') {
          newValues.merchant_number = {
            v1: newValues.selectedHierarchies.v1[0][3].map(e => e.mainLine),
          };
        }
      }
    }

    if(this.state.canViewEvoAccountsSelector || this.state.canViewGpnAccountsSelector|| this.state.canViewHpyAccountsSelector || this.state.canViewGpeAccountsSelector){
      if (newValues.manualSearchMid && newValues.manualSearchMid[0]?.length > 0) {
        newValues.chain = {};
        newValues.corporate = {};
        newValues.opco = {};
        newValues.acquirer = {};
        newValues.contract = {};
        let merchantArray = Array.from(newValues.manualSearchMid[0].split(","))
        newValues.merchant_number = { v1: [] };
        merchantArray.map((merchant) => {
          newValues.merchant_number.v1.push(merchant);
        });
      }
      this.setState({
        selectedRow: newValues.row,
      });
    }
    newFilterValues = Object.keys(newValues).map((key) => {
      if (newValues[key] && (newValues[key].v1 || newValues[key].v2)) {
        // 'opco' is exposed to the search API as 'company' (see prepareResponseForSearchApi),
        // so also accept a 'company' elementId here in case the filter metadata list defines it that way.
        const metaData = filterList.find((filter) => {
          return filter.elementId === key || (key === 'opco' && filter.elementId === 'company');
        });
        if(metaData !== undefined) {
          return Object.assign({}, newValues[key], {
            id: key,
            elementCategoryName: metaData.elementCategoryName,
            elementTypeName: metaData.elementTypeName
          });
        }
      }
    });
    return newFilterValues.filter(filterVal => filterVal != undefined);
  };

  prepareResponseForSearchApi(newActiveFilters) {
    let filters = [];
    newActiveFilters.forEach((newActiveFilter) => {
      const filter = {
        fieldId: newActiveFilter.id === 'opco' ? 'company' : newActiveFilter.id,
        fieldValues1: this.setFieldValue(newActiveFilter),
        fieldvalue2: (newActiveFilter.v2 && newActiveFilter.name.includes('Date')) ? this.changeDateFormat(newActiveFilter.v2, 'YYYY/MM/DD') : newActiveFilter.v2,
      };

      if (newActiveFilter.id == 'case_first_six_mask-case_last_four_mask' && newActiveFilter.v1 == undefined) {
        filter.fieldValues1 = [""];
        filters.push(filter);
      } else if ((newActiveFilter.v1 && newActiveFilter.v1.length != 0) || (newActiveFilter.v2 && newActiveFilter.v2.length != 0)) { filters.push(filter); }
    });
    return filters;
  };

  setFieldValue(newActiveFilter) {
    if (newActiveFilter.name.includes('Date') && newActiveFilter.v1.split('/').length > 1) { return this.changeDateFormat(newActiveFilter.v1, 'YYYY/MM/DD').split(); }
    return newActiveFilter.v1 != undefined && !isObject(newActiveFilter.v1) ? newActiveFilter.v1.split() : newActiveFilter.v1;
  };

  prepareSaveFitlerValueResponse(filters) {
    let filterValues = [];
    this.mapActiveFilters(filters, this.state.finalFilterElements).forEach((filter) => {
      if (filter.category === 'FROM-TO') {
        const idArray = filter.id ? filter.id.split('-') : filter.updatedId.split('-');
        idArray.forEach((id, index) => {
          const filterValue = filter[`v${index + 1}`];
          filterValues = filterValues.concat({
            elementId: idArray[index],
            elementValue: filter.elementType === "DATE" ? this.changeDateFormat(filterValue, 'YYYY-MM-DD') : filterValue ? filterValue : '',
          });
        })
      }
      else if (filter.elementType === "MULTISELECT") {
        filter.v1.forEach((value, index) => {
          filterValues = filterValues.concat({
            elementId: filter.id,
            elementValue: filter.v1[index],
          })
        })
      }
      else
        filterValues = filterValues.concat({
          elementId: filter.id ? filter.id : filter.updatedId,
          elementValue: filter.v1 ? filter.v1.includes('All')?filter.v2: filter.v1: '',
        });
    })
    return filterValues;
  };

  getTokenFromCardNumber(cardNumber, filters) {
    return getToken(cardNumber)
      .then((apiResponse) => {
        if (apiResponse.status.statusCode === 2000) {
          const updatedFilters = filters.map(function (obj) {
            if (obj.fieldId == 'case_account_number')
              return { ...obj, fieldValues1: apiResponse.data.GlobalToken.split("/") };
            return { ...obj };
          });
          this.getDataAccordingToSearchFilters(updatedFilters, getCaseSearchFilterList().id, 0, getCaseSearchFilterList().pageSize, this.state.gridSortArray);
        }
      })
      .catch((error) => {
        this.setState({ caseDataErr: true, isLoading: false });
        console.log('Error Occured while tokenizing Card Number', error);
      });

  };

  changeDateFormat(filterValue, dateFormat) {
    return (filterValue)
      ?
      (
        (filterValue.split('/').length > 1 || filterValue.split('-').length > 1)
          ?
          moment(filterValue).format(dateFormat)
          :
          filterValue
      )
      :
      '';
  };

  mergeSavedElementIdsForRangeElements(savedFilters) {
    let finalSavedFilters = [];
    savedFilters.forEach((savedFilter) => {
      let targetObjects = [];
      savedFilter.filterParams.forEach((filterElement1) => {
        const toElementClone = {};
        if (filterElement1.elementCategoryName === 'FROM') {
          const dateFormat = 'MM/DD/YYYY';
          const toElement = savedFilter.filterParams.find((filterElement2) => {
            return filterElement2.elementSequenceNumber === filterElement1.elementSequenceNumber && filterElement2.elementCategoryName === 'TO';
          });
          toElementClone.id = toElement !== undefined ? `${filterElement1.elementId}-${toElement.elementId}` : `${filterElement1.elementId}`;
          toElementClone.v1 = filterElement1.elementTypeName === 'DATE' ? this.changeDateFormat(filterElement1.elementValue, dateFormat) : `${filterElement1.elementValue}`;
          if (toElement !== undefined && toElement.elementValue !== undefined) {
            toElementClone.v2 = toElement.elementTypeName === 'DATE' ? this.changeDateFormat(toElement.elementValue, dateFormat) : `${toElement.elementValue}`;
          }
          targetObjects = targetObjects.concat(toElementClone);
        } else if (filterElement1.elementCategoryName !== 'TO') {
          toElementClone.id = `${filterElement1.elementId}`;
          toElementClone.v1 = filterElement1.elementTypeName !== 'MULTISELECT' ? `${filterElement1.elementValue}` : `${filterElement1.elementValue}`.split(',');
          targetObjects = targetObjects.concat(toElementClone);
        }
      });
      finalSavedFilters = finalSavedFilters.concat({ ...savedFilter, filterParams: targetObjects });
    });
    return finalSavedFilters;
  };

  closeFilterPane = () => {
    scroll(0, 0);
    this.props.setSearchOpenFlag(false);
    this.setState({ isVisible: false });
  };

  resetScrollPos() {
    this.state.scrollPos = 0;
  };

  exportAction = (fileObject) => {
    this.toggleFileExport();
    let isAllColumns = fileObject.exportType.value === 'all-columns' ? true : false;
    let fileType = fileObject.fileType.value;
    let fileName = fileObject.fileName;
    this.state.totalRecords > 25000 ?
      this.setState({
        setSize: true,
      })
      :
      this.exportFile(fileName, fileType, isAllColumns);
  };

  exportFile(fileName, fileType, isAllColumns) {
    const sortObj = this.state.gridSortArray.map(obj => {
      return {
        fieldId: getCaseSearchFilterList().elementIDs.find(data => data.columnKey == obj.key) !== undefined && getCaseSearchFilterList().elementIDs.find(data => data.columnKey == obj.key).elementId,
        orderByProperty: (obj.order) ? 'ASC' : 'DESC',
      }
    })

    let acquirerList = getAcquirerAccessList();
    let queueExportData = {
      fileType: fileType,
      isAllColumns: isAllColumns,
      pageId: getCaseSearchFilterList().pageId,
      searchFilterInput: {
        filterTypeId: this.state.filterTypeId,
        searchFilterInputElements: this.state.appliedFilters,
        size: this.state.totalRecords,
        sortingElement: sortObj,
        acquirerAccessList: acquirerList,
      }
    }
    this.setState({ exporting: true });
    exportCaseSearchQueueData(queueExportData).then((response) => {
      downloadFile(fileName, fileType, response);
      this.setState({ exporting: false });
    })
    .catch((error) => {
      this.setState({ exporting: false });
      console.log('Error Occured while exporting the case', error);
    });
  };

  checkSize() {
    this.props.setNotification([{
      title: `Error Occured`,
      descriptionStyle: "color: 'grey'",
      description: 'Your export request has exceeded the limitation of 25,000 rows.  Please apply additional filters to reduce of number rows.',
      type: 'danger',
      noActions: true,
      cancelOnly: true,
      closeNotification: () => this.props.closeNotification(),
    }]);
    this.setState({
      setSize: false,
    })
  };

  onSearchChange = (filterText) => {
    this.setState({ filterText });
  };

  handleSort = (key) => {
    const newSortArray = this.state.gridSortArray.some(ele => ele.key === key)
      ? this.state.gridSortArray
          .filter(element => element.key === key)
          ?.map(element => ({ key, order: (element.order + 1) % 2 }))
      : [{ key, order: 1 }];
    this.setState({
      currentPage: 1,
      agLoader: true,
      isLoading: true,
    });
    this.getDataAccordingToSearchFilters(this.state.appliedFilters, getCaseSearchFilterList().id, 0, this.state.recordsShown, newSortArray);
  };

  toggleFileExport = () => {
    this.setState({ filterExportIsVisible: !this.state.filterExportIsVisible });
  };

  closeBanner = () => {
    this.setState({
      isRequiredFilter: false,
      isInvalidFilter: false,
    });
  };

  toggleDropdown(event) {
    event.persist();
    const id = event.currentTarget.id;
    const dropdownToggled = this.state.dropdownToggled;
    dropdownToggled[`${id}`] = !dropdownToggled[`${id}`];
    this.setState({ dropdownToggled });
  };

  onRowClick = (event, sequenceKey) => {
    if ((!event.target.id &&
      !event.target.classList.contains('gd-row-actions') &&
      !event.target.classList.contains('dropdown-menu-trigger')) ||
      event.target.parentNode.classList.contains('primary')) {
      alert(`Row #${sequenceKey} clicked.`); // eslint-disable-line
    }
  };

  rowActionClick(selectedKeyIndex, key) {
    switch (key) {
      case 'OPEN_CASE':
        this.setState({
          selectedKeyIndex,
        });
        this.gotoCaseLandingPage(selectedKeyIndex);
        break;
      case 'OPEN_CASE_IN_TAB':
        gotoNewTabCaseLandingPage(this.state.caseData[selectedKeyIndex].caseNumber);
        break;
      default:
        break;
    }
  };

  gotoCaseLandingPage(selectedKeyIndex) {
    this.props.history.push({
      state: {
        data: this.state.caseData[selectedKeyIndex],
        prevPath: this.props.location.pathname,
      },
      pathname: '/caselanding/' + `${this.state.caseData[selectedKeyIndex].caseNumber}`,
    });
  };

  onBookMarked(key, caseStageId) {
    const rowData = this.state.caseData[key].caseStageId;
    let presenceIndex = this.state.bookMarkedRows.findIndex(row => row === caseStageId);
    if (rowData) {
      if (presenceIndex === -1) {
        return postBookMarkCase(rowData)
          .then(() => {
            this.setState((prevState) => ({
              bookMarkedRows: prevState.bookMarkedRows.concat(caseStageId),
            }));
          })
          .catch((error) => {
            console.log('Error Occured while Bookmarking the case', error);
          });
      }
      else {
        return undoBookMarkCase(rowData)
          .then(() => {
            this.setState((prevState) => ({
              bookMarkedRows: prevState.bookMarkedRows.filter(row => row !== caseStageId),
            }));
          })
          .catch((error) => {
            console.log('Error Occured while un-bookmarking the case', error);
          });
      }
    }
  };

  saveCurrentlyVisibleColumns(columns) {
    this.setState({
      dataColumns: columns,
    });
    const activeDataColumns = [];
    columns.forEach((column) => {
      if (column.displayType !== 'ICON') {
        const activeColumn = {
          columnId: column.columnId,
          displayOrder: column.displayOrder,
        };
        activeDataColumns.push(activeColumn);
      }
    });
    this.postActiveFilters(activeDataColumns);
  };

  postActiveFilters(columns) {
    return postActiveFilters(getCaseSearchFilterList().pageId, columns)
      .then((apiResponse) => {
        this.props.fetchDataColumns(getCaseSearchFilterList().pageId);
        this.setState({
          caseDataErr: false,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({ caseDataErr: true, isLoading: false });
        console.log('Error Occured while saving active data columns', error);
      });
  };

  loadDataOnScroll = () => {
    if (!(this.state.totalRecords - this.state.data.length <= 0)) {
      this.getDataAccordingToSearchFilters(this.state.appliedFilters, this.state.filterTypeId, this.state.lazyLoadPageNumber + 1, this.state.recordsShown, this.state.gridSortArray, true);
    } else {
      this.setState({
        isLoadingComplete: false,
      });
    }
  };

  toggleSavedFilter = () => {
    this.setState((prevState) => ({
      saveFilterToggled: !prevState.saveFilterToggled
    }));
  };

  saveFilterName = () => {
    const updateIndex = this.state.savedFilters.findIndex((caseObject) => {
      return caseObject.filterName === this.state.filterName;
    });
    if (updateIndex == -1) {
      let filtesToSave = this.prepareSaveFitlerValueResponse(this.state.activeFilters);
      this.props.saveActiveFilters(getCaseSearchFilterList().id, filtesToSave, this.state.filterName);
      this.setState({ filterName: '', saveFilterToggled: false });
    } else {
      this.setState({
        saveFilterFail: true,
        filterName: '',
      });
    }
  };

  updateSearchField(value) {
    const lowercaseSearchTerm =
      value && value.toLowerCase && value.toLowerCase();
    const filteredFilters = this.props.savedFilters.filter((filter) => {
      // the most redundant, yet appropriate name ever
      const lowercaseFilterName = filter.filterName.toLowerCase();
      return lowercaseFilterName.includes(lowercaseSearchTerm);
    });
    this.setState({
      currentSearchTerm: value,
      savedFilters: this.mergeSavedElementIdsForRangeElements(filteredFilters),
    });
  };

  setSavedFilterAsActive(id) {
    let index = -1;
    const newFilters = this.state.savedFilters.map((filter) => {
      index++;
      return Object.assign({}, filter, {
        isActive: filter.filterId === id,
      });
    });
    this.setState(
      {
        savedFilters: newFilters,
        isOpenSavedFilterDropdown: false,
      },
      () => {
        const filterSetToUse = this.state.savedFilters.find(
          (set) => set.isActive,
        );
        this.applySavedFilterSet(filterSetToUse);
      },
    );
  };

  applySavedFilterSet(filterSetToUse) {
    const newActiveFiltersStr = filterSetToUse.filterParams;
    const newActiveFilters = this.mapActiveFilters(newActiveFiltersStr, this.state.finalFilterElements);
    this.setState({
      activeFilters: newActiveFilters,
    }, () => {
      const body = document.querySelector('body');
      const e = document.createEvent('MouseEvents');
      e.initEvent('mousedown', true, true);
      body.dispatchEvent(e);
    });
    this.setState(
      {
        isVisible: true,
      },
    );
  };

  clearAllFilters() {
    this.setState(
      {
        caseData : [],
        isVisible: true,
        isTableVisible: false,
        activeFilters: [],
        savedFilters: mapSavedFilters(this.state.savedFilters),
        prepopulatedMerchantId:"",
        selectedRow: [],
      }
    );
  };

  removeSavedFilter(id) {
    const newFilters = this.state.savedFilters.filter((filter) => {
      return filter.id !== id;
    });
    this.props.deleteSavedFilters(id, this.state.searchTypeId);

    this.setState(
      {
        savedFilters: newFilters,
        isOpenSavedFilterDropdown: false,
      },
      () => {
        const body = document.querySelector('body');
        const e = document.createEvent('MouseEvents');
        e.initEvent('mousedown', true, true);
        body.dispatchEvent(e);
      },
    );
  };

  onChange(event) {
    if (event.target) {
      this.setState({ [event.target.name]: event.target.value });
    }
  };

  mergeElementIdsForRangeElements(filters) {
    let targetObjects = [];
    filters.forEach((filterElement1) => {
      let toElementClone = {};

      if (filterElement1.elementCategoryName === 'FROM') {
        const toElement = filters.find((filterElement2) => {
          return filterElement2.elementSequenceNumber === filterElement1.elementSequenceNumber && filterElement2.elementCategoryName === 'TO';
        });

        toElementClone = { ...toElement };
        toElementClone.elementId = `${filterElement1.elementId}-${toElement.elementId}`;
        toElementClone.elementCategoryName = `${filterElement1.elementCategoryName}-${toElement.elementCategoryName}`;
        targetObjects = targetObjects.concat(toElementClone);
      } else if (filterElement1.elementCategoryName !== 'TO') { targetObjects = targetObjects.concat(filterElement1); }
    });
    return targetObjects;
  };

  deactivateFilter(id) {
    const newFilters = this.state.activeFilters.filter((filter) => {
      return filter.id !== id;
    });

    this.setState({
      activeFilters: this.mapActiveFilters(newFilters, this.state.finalFilterElements),
      savedFilters: mapSavedFilters(this.state.savedFilters, newFilters),
    });
  };

  closeSaveFilterFailBanner() {
    this.setState({
      saveFilterFail: false
    });
  };

  setRecordCount = (recordCount, totalRecords) => {
    this.setState({
      recordsShown: recordCount,
      totalRecords: totalRecords,
    })
  };

  setAggridCaseData = (data, pageNum, sortArray) => {
    this.setState((prevState) => ({
      caseData: (this.state.isFirstCall || pageNum == 1) ? data : prevState.caseData.concat(data),
      isFirstCall: false,
      gridSortArray: sortArray,
    }))
  };

  setDataError = () => {
    this.setState({
      caseDataErr: true,
    })
  };

  serverSideData = (props, thisObject) => {
    return {
      getRows(params) {
        document.addEventListener('click', (e) => {
              document.isControl = !!e.ctrlKey;
        });
        let acquirerAccessList= getAcquirerAccessList();
        const newSortArray = params?.api?.getColumnState()
          ?.filter(ele => ele?.sort)
          ?.map(({ colId, sort }) => ({ key:colId, order: sort === 'asc' ? 1 : 0 }));
        const tempSortArray = newSortArray.map(obj => ({
            key: getCaseSearchFilterList().elementIDs.find(data => data.columnKey == obj.key) !== undefined && getCaseSearchFilterList().elementIDs.find(data => data.columnKey == obj.key).elementId,
            order: obj.order,
        }));
        const totalRecords = thisObject.state?.totalRecords || 0;
        if(!thisObject.state.isSortClicked) {
          const updatedPageNumber = thisObject.state.isColumnChanged ? 0 : thisObject.state.pageNumber;
          return getDataAccordingToSearchFilters(props.appliedFilterParams, props.filterTypeId, updatedPageNumber, 25, tempSortArray, acquirerAccessList)
            .then((apiResponse) => {
              let count = apiResponse.data.pageable.offset + apiResponse.data.numberOfElements;
              props.setRecordCount(count, apiResponse.data.totalElements);
              const formattedData = apiResponse.data.content;
              const pageNum = updatedPageNumber + 1;
              props.setAggridCaseData(formattedData, pageNum, newSortArray);
              flushSync(()=> {
                thisObject.setState({
                  pageNumber: pageNum,
                  isLoading: false,
                  isSortClicked: false,
                  acquirerAccessList: acquirerAccessList,
                  isColumnChanged: false,
                })
              });
              const isLastPage = apiResponse?.data?.last;
              const rowCount = isLastPage ? (apiResponse.data.pageable.offset + formattedData.length) : undefined;
              params.success({
                rowData: formattedData,
                rowCount: rowCount,                
              });
              setTimeout(() => {
                thisObject.autoSizeAllColumns(params?.api?.getColumnDefs());
              }, 100);
            })
            .catch((error) => {
              props.setDataError();
              flushSync(()=> {
                thisObject.setState({
                  isSortClicked: false,
                  isColumnChanged: false,
                })
              });
              params.fail();
              console.log('Error Occured while fetching unmatched case details', error);
            });

        } else {
          params.success({
            rowData: [],
            rowCount: totalRecords,
          });
        }
      }
    }
  };

  render() {
    window.document.title = 'Case Search';
    const filterPaneTriggerClasses = classnames('filter-pane-trigger', {
      'is-disabled': false,
    });
    let report = Object.assign({}, this.state.structureMetaData);
    report.dataColumns = Object.assign([], addIconsToGDTableHeadersList(this.state.dataColumns));
    return (
      <section>
        {this.state.setSize == true &&
          this.checkSize()
        }
        <div className={this.props.isSearchActive ? 'main-content--header reports-container--header secondary-header' : 'main-content--header reports-container--header'} style={{ zIndex: 3 }}>
          <h1>{getCaseSearchFilterList().headerName}</h1>
          {/*saved filter starts*/}
          <div className="flex-right" style={{ marginLeft: 500 }}>{/*TODO Remove inline Css*/}
            <div className="gd-report-runner__actions">
              <div className="gd-report-runner__actions-filters">
                <a data-tip data-for="filtering" data-offset="{'right': 320}">
                  <GDActiveFiltersDropdown
                    activeFilters={this.state.activeFilters}
                    dateFormat={this.state.dateFormat}
                    deactivateFilter={this.deactivateFilter}
                    dropdownToggled={this.state.dropdownToggled}
                    filterDefinitions={this.state.finalFilterElements}
                    toggleDropdown={this.toggleDropdown}
                    translations={getFilterTranslations()}
                  />
                </a>
              </div>
              {this.state.activeFilters.length > 0 && (
                <div className="gd-report-runner__actions-clear">
                  <LinkInlineButton action={this.clearAllFilters}>
                    Clear All
                  </LinkInlineButton>
                  <span>&nbsp;|&nbsp;</span>
                </div>
              )}
              <div className="gd-report-runner__actions-save">
                <LinkInlineButton
                  action={this.toggleSavedFilter}
                  disabled={this.props.isProvidingSupport}
                >
                  Save
                </LinkInlineButton>
                {
                  this.state.saveFilterToggled && (
                    <GDNewFilterDropdown
                      toggleDropdown={this.toggleSavedFilter}
                      onChange={this.onChange}
                      saveFilterName={this.saveFilterName}
                      translations={getFilterTranslations()}
                      value={this.state.filterName}
                    />
                  )
                }
              </div>
            </div>
            <div className="gd-filters-dropdown__wrapper gd-report-runner__icon-popup-wrapper">
              <OptionBoxPopup
                icon={StarIcon}
                id={getCaseSearchFilterList().pageId}
                triggerText=""
                showHelpText={getTranslations().savedFilters}
              >
                <GDSavedFiltersDropdown
                  noSavedFilters={this.state.noSavedFilters}
                  onChange={this.updateSearchField}
                  removeSavedFilter={this.removeSavedFilter}
                  savedFilters={this.state.savedFilters}
                  searchTerm={this.state.currentSearchTerm}
                  setSavedFilterAsActive={this.setSavedFilterAsActive}
                  translations={getFilterTranslations()}
                />
              </OptionBoxPopup>
            </div>
            {/*saved filter ends*/}
            <div
              role="button"
              tabIndex={0}
              id="Settled Batches_filter_btn"
              className={filterPaneTriggerClasses}
              onClick={this.toggleFilterPane}
              aria-expanded={this.state.isVisible}
            >
              <span className="gd-report-runner__filter-toggle">Search</span>
            </div>
          </div>
        </div>
        <div className={this.state.isVisible && this.props.isSearchActive ? '' : 'main-content--wrapper'}>
          {
            this.state.isVisible && this.state.finalFilterElements.length > 0 && (
              <div className={this.props.isSearchActive ? '' : 'gd-filter-pane__wrapper'}>
                <FilterPane
                  applyFilters={this.applyFilters}
                  selectedRow={this.state.selectedRow}
                  merchant_hierarchy={this.state.merchant_hierarchy}
                  closeFilterPane={this.closeFilterPane}
                  currentValues={this.state.activeFilters}
                  dateFormat={this.state.dateFormat}
                  filterList={this.state.finalFilterElements}
                  isVisible={this.state.isVisible}
                  translations={getFilterTranslations()}
                  reportName="Received Disputes_filterPane"
                  extraClass="some-class"
                  resetScrollPos={this.resetScrollPos}
                  showMoreFilters={this.showMoreFilters}
                  clearAllFilters={this.clearAllFilters}
                  showDynamicFilter={false}
                  canViewHierarchySelector={this.state.canViewHierarchySelector}
                  canViewGpnAccountsSelector={this.state.canViewGpnAccountsSelector}
                   canViewEvoAccountsSelector={this.state.canViewEvoAccountsSelector}
                  canViewHpyAccountsSelector={this.state.canViewHpyAccountsSelector}
                  canViewGpeAccountsSelector={this.state.canViewGpeAccountsSelector}
                  handleMIDSearch={this.handleMIDSearch}
                  showRemoveLabel = {false}
                />
              </div>
            )
          }
          {
            this.state.isLoading && (
              <div className="ball-sync-loader loader" style={{ height: 200, backgroundColor: 'white' }}>
                <BVLoader20 />
              </div>
            )
          }
          {
            !this.state.isLoading && !this.state.caseDataErr && this.state.isTableVisible && this.state.dataColumns && this.state.dataColumns?.length > 0 && (
              <div className="case-search-content" ref={((ref) => (this.gdTable = ref))}>
                <GDTable
                  actionButtonText="Actions"
                  addIconsToGDTableHeadersList={addIconsToGDTableHeadersList}
                  appliedFilterParams={this.state.appliedFilters}
                  bookMarkedRows={this.state.bookMarkedRows}
                  className=""
                  currentPage={this.state.currentPage}
                  data={this.state.data}
                  dateFormat={this.state.dateFormat}
                  exportAction={this.exportAction}
                  exportFileName={getCaseSearchFilterList().headerName}
                  exporting={this.state.exporting}
                  filterExportIsVisible={this.state.filterExportIsVisible}
                  filterText={this.state.filterText}
                  filterTypeId={getCaseSearchFilterList().id}
                  handleSort={this.handleSort}
                  isAgGrid={true}
                  isLoading={this.state.isLoadingComplete}
                  isNextPage={this.state.isNextPage}
                  isPagable={false}
                  loadDataOnScroll={this.loadDataOnScroll}
                  onBookMarked={this.onBookMarked}
                  onRowClick={this.onRowClick}
                  onSearchChange={this.onSearchChange}
                  pageHandler={this.pageHandler}
                  recordsCountText={{ showingRecords: 'Showing records', preposition: 'of' }}
                  recordsShown={this.state.recordsShown}
                  report={report}
                  rowActionClick={this.rowActionClick}
                  saveCurrentlyVisibleColumns={this.saveCurrentlyVisibleColumns}
                  serverSideData={this.serverSideData}
                  setAggridCaseData={this.setAggridCaseData}
                  setDataError={this.setDataError}
                  setRecordCount={this.setRecordCount}
                  sort={this.state.gridSortArray}
                  toggleFileExport={this.toggleFileExport}
                  totalPages={this.state.totalPages}
                  totalRecords={this.state.totalRecords}
                  translations={getTranslations()}
                />
              </div>
            )
          }
          {
            this.state.caseDataErr && !this.state.loading && (
              <EmptyState
                translations={{ emptyStateHeading: 'Data not available.', emptyStateDescription: 'Please try after sometime' }}

              />
            )
          }
          {
            this.state.isInvalidFilter && (
              <ImagePortal>
              <ResponseBanner
                titleStyle={{ color: 'light-green' }}
                descriptionStyle={{ color: 'grey' }}
                valueStyle={{ color: 'black' }}
                title="Validation Error"
                description="Enter Merchant hierarchy or Case Number for case search to proceed"
                type="danger"
                onClose={this.closeBanner}
                cancelButtonText="DISMISS"
                primaryButtonText="OKAY, DO SOMETHING TO FIX IT"
                primaryButtonAction={this.closeBanner}
              />
              </ImagePortal>
            )
          }
          {
            this.state.isRequiredFilter && (
              <ImagePortal>
              <ResponseBanner
                titleStyle={{ color: 'light-green' }}
                descriptionStyle={{ color: 'grey' }}
                valueStyle={{ color: 'black' }}
                title="Validation Error"
                description="Atleast one field is required for search"
                type="danger"
                onClose={this.closeBanner}
                cancelButtonText="DISMISS"
                primaryButtonText="OKAY, DO SOMETHING TO FIX IT"
                primaryButtonAction={this.closeBanner}
              />
              </ImagePortal>
            )
          }

          {
            this.state.saveFilterFail && (
              <div>
                <ImagePortal>
                <ResponseBanner
                  titleStyle={{ color: 'light-green' }}
                  descriptionStyle={{ color: 'grey' }}
                  valueStyle={{ color: 'black' }}
                  title="Error Occured"
                  description="Filter name already present.Please enter unique filter name"
                  type="danger"
                  onClose={this.closeSaveFilterFailBanner}
                  cancelButtonText="DISMISS"
                  primaryButtonActionValue=""
                  primaryButtonText="OKAY, DO SOMETHING TO FIX IT"
                  primaryButtonAction={this.closeSaveFilterFailBanner}
                />
                </ImagePortal>
              </div>
            )
          }
        </div>
      </section>
    );
  }
}

CaseSearch.propTypes = {
  filters: PropTypes.array,
  setSearchOpenFlag: PropTypes.func,
  isSearchActive: PropTypes.bool,
  setNotification: PropTypes.func,
  closeNotification: PropTypes.func,
};

CaseSearch.defaultProps = {
  filters: [],
};

const mapStateToProps = (state) => ({
  filters: state.searchFilter.filters,
  isSearchActive: state.appSearch.isSearchActive,
  dataColumns: state.dataColumns?.columns,
  savedFilters: state.savedFilter.filters,
  searchTypeId: state.searchFilter.searchTypeId,
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchFilterElements: (searchTypeId) => {
      dispatch(fetchFilterElements(searchTypeId));
    },
    setSearchOpenFlag: (isSearchActive) => {
      dispatch(setSearchOpenFlag(isSearchActive));
    },
    fetchDataColumns: (pageId) => {
      dispatch(fetchDataColumns(pageId));
    },
    saveActiveFilters: (searchTypeId, activeFilters, filterName) => {
      dispatch(saveActiveFilters(searchTypeId, activeFilters, filterName));
    },
    fetchSearchTypeIdBasedOnSearchName: (searchTypeId) => {
      dispatch(fetchSearchTypeIdBasedOnSearchName(searchTypeId));
    },
    fetchSavedFilterElements: (searchTypeId) => {
      dispatch(fetchSavedFilterElements(searchTypeId));
    },
    deleteSavedFilters: (filterId, searchTypeId) => {
      dispatch(deleteSavedFilters(filterId, searchTypeId));
    },
    setNotification: (banner) => dispatch(dangerNotificationBanner(banner)),
    closeNotification: () => dispatch(closeNotificationBanner()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseSearch);
